import { fromJS } from 'immutable';

// This is duplicated in ReservedPrefix.py

export const reservedPrefixes = fromJS([
  'about',
  'accounts',
  'admin',
  'api',
  'apps',
  'assessment',
  'auth',
  'blog',
  'certification',
  'cohorts',
  'commenting',
  'conferences',
  'contact',
  'content',
  'courseimages',
  'courses',
  'data',
  'developer',
  'embed',
  'gallery',
  'gigya',
  'go',
  'help',
  'institution',
  'invoices',
  'jobs',
  'join',
  'json',
  'listActivities',
  'lti',
  'marking',
  'media',
  'notifications',
  'oauth',
  'oauth-redirect',
  'openeducators',
  'opencred', // reserved for mapping it to accredible department, we dont want someone to create a portal with this name.
  'pages',
  'payment',
  'payments',
  'pedagogy',
  'press',
  'pricing',
  'privacypolicy',
  'progress',
  'pwa',
  'saml',
  'search',
  'sso',
  'sso-complete',
  'sso-fail',
  'sso-fallback',
  'sso-provision',
  'status',
  'subscription',
  'subscriptions',
  'suggest',
  'super',
  'support',
  'tags',
  'teachathon',
  'team',
  'termsofservice',
  'thankyou',
  'u',
  'usertracking',
  'validate',
  'voting',
  'wasabi',
  'youtube',
  'ended_error',
]);
